import { useState } from "react";
import { Box, Button, Drawer, Fab, IconButton, TextField, Typography } from "@mui/material";
import { Add as AddIcon, Close as CloseIcon } from "@mui/icons-material";

const UserForm = ({ onSubmit }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [count, setCount] = useState("");
    const [errors, setErrors] = useState({});

    const handleDrawerOpen = () => {
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
        setCount("");
        setErrors({});
    };

    const handleSubmit = async () => {
        const numValue = parseInt(count, 10);
        if (count === "" || isNaN(numValue) || numValue <= 0) {
            setErrors({ count: "Count must be greater than 0" });
            return;
        }
        setErrors({});
        await onSubmit(numValue);
        handleDrawerClose();
    };

    return (
        <>
            <Fab
                color="primary"
                aria-label="add"
                style={{ position: "fixed", bottom: 20, right: 20 }}
                onClick={handleDrawerOpen}
            >
                <AddIcon />
            </Fab>
            <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
                <Box sx={{ width: 400, p: 3 }}>
                    <IconButton
                        onClick={handleDrawerClose}
                        style={{ position: "absolute", right: 10, top: 10 }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" gutterBottom>
                        Add New Users
                    </Typography>
                    <TextField
                        label="Count"
                        type="number"
                        variant="outlined"
                        fullWidth
                        value={count}
                        onChange={(e) => {
                            setCount(e.target.value);
                            if (errors.count) {
                                setErrors({});
                            }
                        }}
                        error={!!errors.count}
                        helperText={errors.count}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        style={{ marginTop: 20 }}
                    >
                        Add Users
                    </Button>
                </Box>
            </Drawer>
        </>
    );
};

export default UserForm;
